import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';

const AdmissionsFormForAdminQuery = graphql.persisted(
  "AdmissionsFormForAdmin",
  graphql(`
    query AdmissionsFormForAdmin($familyEnrollmentId: String!) {
      admissionsFormForAdmin(familyEnrollmentId: $familyEnrollmentId) {
        familyEnrollment {
          id
          state
          enrollmentKind
          family {
            id
            name
          }
          studentEnrollments {
            id
            state
            gradeLevel
            person {
              id
              firstName
              lastName
            }
          }
        }
        formData
        formMetadata
        formAnswers
        formState
        schoolYearName
        tuitionOptions
        gradeLevels
        submittedAt
      }
    }
  `)
);

export { AdmissionsFormForAdminQuery };

export function useAdmissionsFormForAdmin(familyEnrollmentId: string | undefined, skip?: boolean) {
  return useQuery(AdmissionsFormForAdminQuery, {
    variables: { familyEnrollmentId: familyEnrollmentId! },
    skip: !familyEnrollmentId || skip,
  });
}
